import { AnalyticsView } from "@/features/S2Dashboard";

export default function AnalyticsPage() {
  return <AnalyticsView />;
}
